import { makeStyles } from "@mui/styles";
import { useEffect, useRef } from "react";

import { getMediaLink } from "../../../../../../utils/mediaLink";

const useStyles = makeStyles({
  container: {
    borderRadius: "30px",
    overflow: "hidden",
    width: "100%",
    display: "flex",
  },
  audio: {
    width: "100%",
    filter: "invert(1)",
    // TODO
    // this is a workaround to style the audio element which only works on wekbit browsers
    // in the future we'll need to implement a better way to style audio component for other browsers.
    // this is 'ok' for now.
    "&::-webkit-media-controls-panel": {
      background: "#cccccc",
    },
  },
});

// interface AudioPlaybackProps {
//   style: proptypes.object,
//   url: proptypes.string,
// };

export default function AudioPlayback(props) {
  const { style, url } = props;
  const audioRef = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    //https://bugs.chromium.org/p/chromium/issues/detail?id=642012
    const handleDurationUpdate = (event) => {
      event.target.currentTime = 0;
      event.target.removeEventListener("timeupdate", handleDurationUpdate);
    };

    //This handles chrome bug where the duration is Infinity or NaN
    if (audioRef.current && (audioRef.current.duration === Infinity || isNaN(Number(audioRef.current.duration)))) {
      audioRef.current.currentTime = 1e101; //set currentTime to a large number then the actuall duration
      audioRef.current.addEventListener("timeupdate", handleDurationUpdate);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener("timeupdate", handleDurationUpdate);
      }
    };
  }, [url]);

  return (
    <div className={classes.container} style={style}>
      <audio
        ref={audioRef}
        data-testid="audio-playback"
        className={classes.audio}
        src={getMediaLink({ link: url })}
        controls
        controlsList="nodownload noplaybackrate"
        preload="auto"
      />
    </div>
  );
}
